export default "__VITE_ASSET__Dxob8HrI__"